"use client";

import React from "react";
import { ArrowRight, Play, Activity, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AdvancedKidneyCareForABetterLife() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="238487" id="compassionate-care-at-home" className="relative overflow-hidden bg-background bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665643/img/care_background_hero.png)] bg-cover bg-center pt-16 pb-12 lg:pt-20 lg:pb-16 text-foreground">
      {}
      <div className="absolute inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[60%] rounded-lg bg-secondary/60 blur-[100px] opacity-70" />
        <div className="absolute top-[40%] -right-[10%] w-[40%] h-[50%] rounded-lg bg-accent/40 blur-[120px] opacity-60" />
      </div>

      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div ref={textRef} className="lg:col-span-7 flex flex-col justify-center transition-all duration-1000 ease-out opacity-100 translate-y-0 bg-cover bg-center bg-no-repeat rounded-2xl p-8 lg:p-12 !bg-[url(https://settled-jaguar.10web.cloud/wp-content/uploads/2026/05/image_5-1.webp)] relative overflow-hidden !bg-[url(https://settled-jaguar.10web.cloud/wp-content/uploads/2026/05/image_5.webp)]">
            <div className="absolute inset-0 bg-background/90 backdrop-blur-[2px] -z-10" />
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-secondary text-secondary-foreground text-sm font-medium mb-6 w-fit shadow-sm">
              <Activity className="size-4" />
              <span>CQC Registered Provider</span>
            </div>
            
            <h1 className="font-default text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-foreground leading-[1.1]">
              Providing{" "}
              <span className="font-serif italic text-ring">
                Compassionate
              </span>
              {" "}Care at Home
            </h1>
            
            <p className="mt-6 text-lg sm:text-xl text-foreground/90 max-w-[90%] leading-relaxed font-sans font-medium">
              Cynthylee Health Care offers premium, CQC-registered home care services across Brighton & Hove. Our dedicated team ensures your loved ones receive professional support in the comfort of their own home.
            </p>
            
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <Button size="lg" asChild className="h-12 px-8 text-base bg-ring hover:bg-ring/90 text-white rounded-lg shadow-md transition-all">
                <Link to="/ServicesPage">
                  View Services
                  <ArrowRight className="ml-2 size-5" />
                </Link>
              </Button>
              <Button variant="outline" size="lg" asChild className="h-12 px-8 text-base bg-background/50 backdrop-blur-sm border-ring text-ring hover:bg-accent rounded-lg shadow-sm">
                <Link to="/ContactPage">
                  Contact Us
                </Link>
              </Button>
            </div>

            <div className="mt-10 flex items-center gap-6 text-sm text-muted-foreground">
              <div className="flex items-center gap-2">
                
                
              </div>
              <div className="flex items-center gap-2">
                <ShieldCheck className="size-5 text-ring" />
                <span className="font-default">Brighton & Hove Local Care</span>
              </div>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-5 relative transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            {}
            <svg width="0" height="0" className="absolute">
              <defs>
                <clipPath id="kidney-mask" clipPathUnits="objectBoundingBox">
                  <path d="M0.5,0.02 C0.85,-0.05 1,0.25 1,0.55 C1,0.85 0.8,1 0.5,0.98 C0.15,0.95 0,0.75 0,0.45 C0,0.15 0.15,0.09 0.5,0.02 Z" />
                </clipPath>
              </defs>
            </svg>

            <div className="relative w-full aspect-[4/5] max-w-md mx-auto lg:max-w-none">
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-ring/20 to-accent/40 rounded-3xl transform rotate-3 scale-105 -z-10 transition-transform duration-700 hover:rotate-6" />
              
              {}
              <div className="w-full h-full bg-muted relative overflow-hidden shadow-xl rounded-lg" style={{
              clipPath: "url(#kidney-mask)"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665643/img/caregiver_elderly_client_brighton.png" alt="Compassionate caregiver supporting an elderly client in a sunlit Brighton home" className="w-full h-full object-cover object-center !bg-transparent !text-[rgba(24,31,37,1)]" src="https://settled-jaguar.10web.cloud/wp-content/uploads/2026/05/image_11.webp" src="https://settled-jaguar.10web.cloud/wp-content/uploads/2026/05/1.jpeg" />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/10 to-transparent pointer-events-none" />
              </div>

              {}
              <div className="absolute -bottom-6 -left-6 bg-card p-4 rounded-2xl shadow-lg border border-border flex items-center gap-4 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-500">
                <div className="flex -space-x-3">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665643/img/caregiver_profile_1.png" alt="Cynthylee Caregiver" className="size-10 rounded-lg border-2 border-card object-cover" />
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665643/img/caregiver_profile_2.png" alt="Cynthylee Specialist" className="size-10 rounded-lg border-2 border-card object-cover" />
                  <div className="size-10 rounded-lg border-2 border-card bg-secondary flex items-center justify-center text-xs font-bold text-secondary-foreground">
                    CQC
                  </div>
                </div>
                <div>
                  <p className="text-sm font-bold text-foreground font-default">Trusted Care</p>
                  <p className="text-xs text-muted-foreground font-sans">Professional & Kind</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}